import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-order-invoice-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './order-invoice.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class OrderInvoiceTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<OrderInvoiceTemplateData>;
}

export type OrderInvoiceTemplateData = {
  title: string;
  invoice_id: string;
  amount_html: string;
  company_name_html: string;
  content_html: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const OrderInvoiceTemplateMocks: OrderInvoiceTemplateData[] = [
  {
    title: 'Order invoice',
    invoice_id: 'QATest-001',
    amount_html: 'Amount: <b>399 EUR</b>',
    company_name_html: 'Company: <b>ACME</b>',
    content_html:
      'To view your invoices, sign in to your account and go to <a href="http://app.recruitee.com/#/settings/pricing/billing">Settings → Billing</a>. If you have any questions, please contact us by replying to this email.<br /><br />Thanks so much for being a Recruitee customer!',
    button_link: 'http://recruitee.com',
    button_text: 'Update billing information now',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
